import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HubspotCrmPromptComponent } from './hubspot-crm-prompt.component';
import { FormsModule } from '@angular/forms';
import { SiModalModule } from '../si-modal';
import {  MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';

@NgModule({
  declarations: [
    HubspotCrmPromptComponent
  ],
    imports: [
        DisableAutocompleteDirectiveModule,
        CommonModule,
        FormsModule,
        SiModalModule,
        MatRadioModule,
        MatButtonModule,
    ],
  exports: [
    HubspotCrmPromptComponent
  ]
})
export class HubspotCrmPromptModule { }
